import { Tabs, SurfaceCard, PageContainer } from '@react-apps/design-system';
import { useRouteTabs } from '@/shared/hooks/use-route-tabs';
import { ProductsPanel } from '../components/ProductsPanel';
import { PerksPanel } from '../components/PerksPanel';
import { PerkPresetsPanel } from '../components/PerkPresetsPanel';
import { RolesPanel } from '../components/RolesPanel';
import { FeaturesPanel } from '../components/FeaturesPanel';

/**
 * Hub do módulo Catálogo: uma aba por área (Produtos, Perks, Presets, Roles,
 * Features). Cada aba é um painel autocontido com sua própria listagem +
 * criação.
 */
const TAB_IDS = ['products', 'perks', 'presets', 'roles', 'features'];

export function CatalogPage() {
  const { activeTab, onTabChange } = useRouteTabs(
    '/management/catalog',
    TAB_IDS,
  );

  return (
    <PageContainer maxWidth="6xl">
      <div>
        <h1 className="text-(--color-text-primary) text-2xl font-semibold">
          Catálogo
        </h1>
        <p className="text-(--color-text-secondary) mt-1 text-sm">
          Gerencie produtos, perks, presets, roles e features da plataforma.
        </p>
      </div>

      <SurfaceCard>
        {/* Aba ativa vem da URL (`/management/catalog/:tab`). */}
        <Tabs
          activeTab={activeTab}
          onTabChange={onTabChange}
          tabs={[
            { id: 'products', label: 'Produtos', content: <ProductsPanel /> },
            { id: 'perks', label: 'Perks', content: <PerksPanel /> },
            {
              id: 'presets',
              label: 'Presets',
              content: <PerkPresetsPanel />,
            },
            { id: 'roles', label: 'Roles', content: <RolesPanel /> },
            { id: 'features', label: 'Features', content: <FeaturesPanel /> },
          ]}
        />
      </SurfaceCard>
    </PageContainer>
  );
}
